import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MapColumns from './MapColumns';
import { getFileMappingInfo } from 'redux/files/FilesActions';
import { setActiveDivision } from 'redux/mapping/MappingActions';

const mapStateToProps = state => ({
  activeDivision: state.mapping.activeDivision,
  fileExtension: state.files.fileExtension,
  divisions: state.mappingFile.divisions,
  delimiter: state.profiles.profile.columnDelimiter
});

const mapDispatchToProps = dispatch => ({
  filesActions: bindActionCreators({ getFileMappingInfo }, dispatch),
  mappingActions: bindActionCreators({ setActiveDivision }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MapColumns);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/MapColumnsConnector.js